import AppForm from '../app-components/Form/AppForm';
import {normalizeFormValue} from '../utils.js';

Vue.component('employee-attendance-form', {
    mixins: [AppForm],
    props: {
        trans: { type: Object },
        quarters: { type: Array }
    },
    
    data: function() {
        return {
            mutableQuarters: this.quarters,
            // server errors by quarter id, shown until the submitted value is changed
            serverErrors: {}
        };
    },

    methods: {
        correctBasicInputDecimals(quarter, $event)
        {
            // empty input stays null (= not imported), it must not turn into 0
            quarter.avgHourSalary = $event.target.value ? this.sanitizeDecimalPoint($event.target.value) : null;
        },
        
        sanitizeDecimalPoint(val)
        {
            val = ""+val;
            return (val ? val.replace(",",".") : val);
        },
        
        getData: function()
        {
            return this.mutableQuarters;
        },

        // balances of all types, the cards are rendered only to users allowed to import the balances
        getBalanceData: function()
        {
            return (this.$refs.balance_cards || []).map(card => card.getData());
        },

        // errors: [{type: 'holiday', field: 'balance_date', msg: '...'}]
        setBalanceServerErrors(errors)
        {
            (this.$refs.balance_cards || []).forEach(card => {
                card.setServerErrors(errors.filter(error => error.type === card.type.key));
            });
        },

        // errors: [{quarter: <copy of the submitted quarter>, msg: '...'}]
        setServerErrors(errors)
        {
            this.clearServerErrors();
            errors.forEach(error => {
                this.$set(this.serverErrors, error.quarter.id, {msg: error.msg, value: normalizeFormValue(error.quarter.avgHourSalary)});
            });
        },

        clearServerErrors()
        {
            this.serverErrors = {};
            this.setBalanceServerErrors([]);
        },

        quarterServerError(quarter)
        {
            const error = quarter && this.serverErrors[quarter.id];
            return error && error.value === normalizeFormValue(quarter.avgHourSalary) ? error.msg : null;
        },

        avgHourSalaryError(quarter)
        {
            return this.errors.first('avg_hour_salary_' + quarter.id) || this.quarterServerError(quarter);
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/EmployeeAttendanceForm.js